module.exports = __webpack_public_path__ + "static/media/blogPostTwo.d73b6fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blogPostTwo.png
// module id = 40
// module chunks = 0